import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import * as echarts from 'echarts'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/map';
import 'echarts/lib/component/geo'


import '@/assets/css/common.scss'

import 'uno.css'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.config.globalProperties.$axios = axios
app.config.globalProperties.$echarts = echarts

app.component('v-chart', ECharts)

app.use(store).use(router).use(ElementPlus).mount('#app')